const highlights = [
  {
    icon: "ri-hd-line",
    title: "高清画质",
    desc: "支持高清播放体验，画面清晰流畅。",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "完全免费",
    desc: "无需付费，打开即看，畅享影视内容。",
  },
  {
    icon: "ri-layout-grid-line",
    title: "分类清晰",
    desc: "电影、电视剧、综艺一目了然，随心筛选。",
  },
  {
    icon: "ri-search-eye-line",
    title: "搜索快捷",
    desc: "关键词秒级匹配，快速找到想看的内容。",
  },
];

export default function PlatformIntro() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 md:px-6 pt-12 md:pt-16">
      <div className="rounded-lg bg-secondary-100 p-6 md:p-10">
        <div className="max-w-2xl">
          <span className="text-xs font-label font-medium uppercase tracking-wider text-primary-600">
            关于平台
          </span>
          <h2 className="mt-2 font-heading text-xl md:text-3xl font-bold text-foreground-950">
            一个更简单的高清观影入口
          </h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
            西瓜视频免费致力于把优质影视内容整理得更清晰。我们按电影、电视剧、综艺分类整理，
            支持关键词搜索与多条件筛选，让你不用在繁杂的片单里反复挑选，几步之内就能找到想看的节目。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {highlights.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-secondary-200 bg-background-50 p-4 md:p-5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="mt-3 font-heading text-sm md:text-base font-semibold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-1 text-xs md:text-sm leading-relaxed text-foreground-600">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        <p className="mt-6 text-xs text-foreground-500">
          提示：本站播放器为前端展示演示，不接入真实视频流；影片信息为虚拟演示数据，仅用于功能与界面展示。
        </p>
      </div>
    </section>
  );
}